<template>
  <v-dialog
    v-model="localDialog"
    width="50%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
  >
    <v-card>
      <v-card-title class="text-h6">
        <span>{{ isEntryMode ? "Add Asset Component" : "Update Asset Component" }}</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form @submit.prevent="submit" ref="assetComponentSetup">
          <v-row>
            <v-col lg="6" md="6" cols="12">
              <v-text-field
                density="compact" 
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="name.value.value"
                :error-messages="name.errorMessage.value"
                clearable
              >
                <template #label>
                  Name <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>

              <v-autocomplete
              density="compact"
              variant="outlined"
              bg-color="grey-lighten-4"
              v-model="asset_status_id.value.value"
              :error-messages="asset_status_id.errorMessage.value"
              clearable
              :items="getAssetStatusTypesList"
              :item-title="item => `${item.name}`"   
              autocomplete="off"                                               
              item-value="id"
              :loading="brandLoading"
              >
              <template #label>
                Status <span class="text-red-accent-4">*</span>
              </template> 
            </v-autocomplete>

            <v-autocomplete
            label="Brand"
            density="compact"
            variant="outlined"
            bg-color="grey-lighten-4"
            v-model="brand_id.value.value"
            :error-messages="brand_id.errorMessage.value"
            clearable
            :items="getBrandList"
            :item-title="item => `${item.name}`"   
            autocomplete="off"                                               
            item-value="id"
            :loading="brandLoading"
            ></v-autocomplete>
            </v-col>

            <v-col lg="6" md="6" cols="12">

              <v-text-field
                label="Unit Price"
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="unit_price.value.value"
                :error-messages="unit_price.errorMessage.value"
                clearable
              >
                <template #label>
                  Unit Price <span class= "text-red-accent-4">*</span>
                </template>
              </v-text-field>

              <v-text-field
                label="Quantity"
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="quantity.value.value"
                :error-messages="quantity.errorMessage.value"
                clearable
              > 
                <template #label>
                  Quantity <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" class="pt-0 pb-4">
              <v-textarea
                label="Description"
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="description.value.value"
                :error-messages="description.errorMessage.value"
                clearable
              ></v-textarea>

              <v-file-input
              v-model="selectedImage"
              label="Component Image"
              accept="image/*"
              density="compact"
              variant="outlined"
              bg-color="grey-lighten-4"
              persistent-hint
              hint="Image must be exactly 120px × 120px"
              show-size
              @input="previewImage"                               
              @click:clear="clearImage"
              prepend-icon=""
              prepend-inner-icon="mdi-camera"
              class="ellipsis-filename"
              title="image"
              >                                                                                                  
              </v-file-input>
              <div style="float: right;">
                  <v-img :src="preview" cover  class="preview-image"></v-img>
              </div>
            </v-col>

          </v-row>

          <v-divider></v-divider>
          <v-card-actions>
            <v-layout class="justify-end">
              <v-btn
                class="bg-red"
                variant="flat"
                type="reset"
                @click="closeDialog"
                >Close</v-btn
              >
              <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                {{ isEntryMode ? "Save" : "Update" }}
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { fileServerUrl } from "@/store/api";
import { getCurrentInstance } from "vue";

const DEFAULT_IMAGE = '/src/assets/no_preview.jpeg';

export default {
  name: "AssetComponentSetup",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({
        name: "",
        asset_register_id: null,
        brand_id: null,
        asset_status_id: null,
        unit_price: "",
        quantity: "",
        description: "",
        image: null,
        remarks: "",
      }),
    },
  },
  data() {
    return {
      mainId :null,
      localDialog: this.dialog,

      selectedImage: null,
      errorMessages: "",
      preview: "/src/assets/no_preview.jpeg",

      loading: false,
      brandLoading: false,
      assetStatusLoading: false,

      isEntryMode: true,
    };
  },
  watch: {
    dialog(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("update:dialog", val);
    },
    data: {
      handler(newData) {
        console.log(newData)
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.asset_component_id.setValue(newData.id || "", false);
        this.name.setValue(newData.name || "", false);
        this.asset_register_id.setValue(newData.asset_register_id || null, false);
        this.brand_id.setValue(newData.brand_id || null, false);
        this.asset_status_id.setValue(newData.asset_status_id || null, false);
        this.unit_price.setValue(newData.unit_price || "", false);
        this.quantity.setValue(newData.quantity || "", false);
        this.description.setValue(newData.description || "", false);
        // this.image.setValue(newData.image || null, false);

        this.preview = newData.image
          ? fileServerUrl + newData.image
          : "/src/assets/no_preview.png";
      },
    },
  },
  created() {
    if(this.$store.getters.getBrandList.length === 0) {
      this.brandLoading = true,
      this.$store.dispatch("getBrandList").then((response) => {
        this.brandLoading = false;
      })
    }
    if(this.$store.getters.getAssetStatusTypesList.length === 0) {
      this.assetStatusLoading = true,
      this.$store.dispatch("getAssetStatusTypesList").then((response) => {
        this.assetStatusLoading = false;
      })
    }
  },
  computed: {
    getBrandList() {
      const brands = this.$store.getters.getBrandList;
      return brands;
    },
    getAssetStatusTypesList() {
      const statusTypes = this.$store.getters.getAssetStatusTypesList;
      return statusTypes;
    }
  },
  methods: {
    previewImage: function(event) {
      this.selectedImage = event.target.files[0];
      const input = event.target;
      if (input.files && input.files[0]) {
              var reader = new FileReader();
              reader.onload = (e) => {
              this.preview = e.target.result;
          }
          this.image = input.files[0];
          reader.readAsDataURL(input.files[0]);
      }
      else {
          this.preview = '/src/assets/no_preview.jpeg';
      }
    },
    clearImage() {
      this.preview = "/src/assets/no_preview.jpeg";
    },
    updateDialog(val) {
      this.$emit("update:dialog", val);
    },
    closeDialog() {
      this.$emit("update:dialog", false);
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        name: yup.string().trim().required("Name is required").max(255, "Name cannot exceed 255 characters").label("Name"),
        asset_status_id: yup.number().typeError("Status type must be selected").required("Asset Status is required").label("Asset Status"),
        quantity: yup.number().typeError("Quantity must be Number").required("Quantity is required").min(1, "Quantity must be at least 1").label("Quantity"),
        unit_price: yup.number().required().typeError("Unit Price must be Number").label("Unit Price"),
      }),
    });

    const asset_component_id = useField("asset_component_id");
    const name = useField("name");
    const asset_register_id =useField("asset_register_id");
    const brand_id = useField("brand_id");
    const asset_status_id = useField("asset_status_id");
    const unit_price = useField("unit_price");
    const quantity = useField("quantity");
    const description = useField("description");
    const image = useField("image");
    const errorMessages = ref("");
    const loading = ref("");
    const selectedImage  = ref(null);
    const preview = ref(DEFAULT_IMAGE);
    const store = useStore();
    
    const submit = handleSubmit((values) => {
      const asset_id = proxy.mainId;
      values.asset_register_id = asset_id;
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        formData.append(key, values[key] || "");
      });
      if (proxy.selectedImage) {
        formData.append("image", proxy.selectedImage);
      }

      store
        .dispatch("saveUpdateAssetComponent", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          resetForm();
          emit("update:dialog", false);
          toast.success(response.data.message);
          proxy.selectedImage = null;
          store.dispatch("getAssetComponentsList", { asset_register_id: asset_id });
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || "Something went wrong");
        });
    });

    return {
        submit,
        name,
        asset_component_id,
        asset_register_id,
        brand_id,
        asset_status_id,
        unit_price,
        quantity,
        description,
        image,
        errorMessages,
        selectedImage,
        preview,
        resetForm,
        loading,
    };
  },
  mounted() {
    const id = this.$route.params.id;
    this.mainId = id;
  },
};
</script>
